// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles__banner___2dH4c","bannerStripe":"styles__bannerStripe___3kZGr"};